
export function easySmoothScroll(options) {
    
    'use strict';
    
    var defaults = {
        element: '.scroll',
        speed: 500,
        offset: 0,
        backTopElement: '.back-top'
    },
        settings = jQuery.extend(true, defaults, options),
        element = settings.element;
    
    jQuery('a' + element).on('click', function (e) {
        
        e.preventDefault();
        
        var offset = (!jQuery(this).data('offset')) ? settings.offset : jQuery(this).data('offset'),
            speed = (!jQuery(this).data('speed')) ? settings.speed : jQuery(this).data('speed'),
            target = jQuery(this).attr('href');
        
        if (jQuery(target).length) {
            jQuery('html,body').animate({
                scrollTop: jQuery(target).offset().top + offset
            }, speed);
            return true;
        } else {
            console.log(' ENOTARGET! Missing target element ');
            return false;
        }

    }); // end click
    
    jQuery('a' + settings.backTopElement).on('click', function (e) {
        
        e.preventDefault();
        
        var offset = (!jQuery(this).data('offset')) ? settings.offset : jQuery(this).data('offset'),
            speed = (!jQuery(this).data('speed')) ? settings.speed : jQuery(this).data('speed');
        
        jQuery('html,body').animate({
            scrollTop: 0 + offset
        }, speed);
        return true;

    }); // end click
    
}